import React from "react";
import { AlertCircle, ExternalLink } from "lucide-react";

// What an unconnected source looks like. It never shows a zero, because a zero
// reads as "nothing happened" when the truth is "we cannot see".
export default function NotConnected({ title, reason, needs = [], links = [], where, testid }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6" data-testid={testid}>
      <div className="flex items-start gap-3">
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-amber-50 text-amber-600">
          <AlertCircle size={18} />
        </span>
        <div className="min-w-0">
          <h3 className="font-bold text-navy">{title}</h3>
          <p className="text-sm text-slate-600 mt-1 leading-relaxed">{reason}</p>
          {needs.length > 0 && (
            <>
              <p className="text-xs font-semibold text-navy mt-4 mb-2">To connect it we need:</p>
              <ul className="space-y-1.5">
                {needs.map((n) => (
                  <li key={n} className="text-xs text-slate-600 flex gap-2">
                    <span className="text-orange font-bold">·</span>
                    <span>{n}</span>
                  </li>
                ))}
              </ul>
            </>
          )}
          {links.length > 0 && (
            <div className="mt-4 flex flex-wrap gap-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`notconnected-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="inline-flex items-center gap-1.5 text-xs font-semibold text-navy hover:text-orange duration-200 [transition-property:color]"
                >
                  {l.label} <ExternalLink size={12} />
                </a>
              ))}
            </div>
          )}
          {where && <p className="text-xs text-slate-400 mt-4">{where}</p>}
        </div>
      </div>
    </div>
  );
}
